import {AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatSelectModule } from '@angular/material/select'
import { MatchService } from '../../../../core/services/matches.service'
import { MatButtonModule } from '@angular/material/button'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { provideNativeDateAdapter } from '@angular/material/core'
import { Player } from '../../../../core/models/player.model'
import { PlayerService } from '../../../../core/services/player.service'
import { MetricsService } from '../../services/season-metrics.service'
import { MatIconModule } from '@angular/material/icon'
import { RouterModule } from '@angular/router'
import { MatChipsModule } from '@angular/material/chips'
import { Metrics } from '../../../../core/models/metrics.model'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { LiveAnnouncer } from '@angular/cdk/a11y'
import { Match } from 'src/app/core/models/match.model'

@Component({
    selector: 'season-metrics-filters-component',
    providers: [provideNativeDateAdapter()],
    standalone: true,
    imports: [
        MatIconModule,
        MatDatepickerModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatChipsModule,
        MatAutocompleteModule,
        RouterModule
    ],
    templateUrl: './season-metrics-filters.component.html',
    styleUrl: './season-metrics-filters.component.css'
})
export class SeasonMetricsFiltersComponent implements AfterViewInit {
  constructor(public service: MetricsService, public playerService: PlayerService, public matchService: MatchService) {}
  submitted:boolean=false
  announcer = inject(LiveAnnouncer)
  separatorKeysCodes: number[] = [ENTER, COMMA]

  starterOptions: string[] = ["Y", "N"]
  stadiumOptions: string[] = ["Casa", "Fuera", "Neutral"]
  metrics: Metrics[] = this.service.METRICS
  metricsFiltered: Metrics[] = []

  matches: Match[] = []
  matchesFiltered: Match[] = []
  rivals: string[] = []
  seasons: string[] = []
  players: Player[] = []
  playersFiltered: Player[] = []

  @ViewChild('chipInput') chipInput!: ElementRef<HTMLInputElement> 
  @ViewChild('playerInput') playerInput!: ElementRef<HTMLInputElement> 

  ngAfterViewInit() {
    //Load matches data
    this.matchService.fetchMatchList()
    .subscribe(response => {
      this.matches = response as Match[]
      this.seasons = [... new Set(this.matches.map(val=>val.season))]
    }) 

    this.playerService.fetchSeasonPlayerList('2023/2024').subscribe(response => {
      this.players = response as Player[]
    }) 

    this.service.filters.get('season')?.valueChanges.subscribe(val=>{
      this.matchesFiltered = this.matches.filter(d => d.season == val)
      this.rivals = [... new Set(this.matchesFiltered.map(val=>val.against!.team.name || val.for!.team.name))]

      //Load players data
      const season = this.service.filters.get('season')?.value
      if(season)
      this.playerService.fetchSeasonPlayerList(season).subscribe(response => {
        this.players = response as Player[]
      }) 
    })
  }

  onSubmit() {
    this.service.FiltersSubmitted()
  }

  add(event: any){
    const value = (event.value || '').trim()
    if (value){
      const metric = this.metrics.filter(m => m.label.toLowerCase().includes(value))
      this.service.metricsSelected.push(metric[0])
    } 
    event.chipInput!.clear()
    this.service.metricsForm.setValue(null)
  }

  removed(chip: Metrics){
    const index = this.service.metricsSelected.indexOf(chip)

    if (index >= 0) {
      this.service.metricsSelected.splice(index, 1)
      this.announcer.announce(`Removed ${chip}`)
    }
  }

  selected(event: any){
    this.service.metricsSelected.push(event.option.value)
    this.chipInput.nativeElement.value = ''
    this.service.metricsForm.setValue(null)
  }

  filter(){
    const filterValue = this.chipInput.nativeElement.value.toLowerCase()
    this.metricsFiltered = this.metrics.filter(m => m.label.toLowerCase().includes(filterValue))
  }

  addPlayer(event: any){
    const value = (event.value || '').trim()
    if (value){
      const player = this.players.find(m => m.name.toLowerCase().includes(value))
      if(player) this.service.playersSelected.push(player)
    } 
    event.playerInput!.clear()
    this.service.playersForm.setValue(null)
  }

  removePlayer(chip: Player){
    const index = this.service.playersSelected.indexOf(chip)

    if (index >= 0) {
      this.service.playersSelected.splice(index, 1)
      this.announcer.announce(`Removed ${chip}`)
    }
  }

  selectPlayer(event: any){
    this.service.playersSelected.push(event.option.value)
    this.playerInput.nativeElement.value = ''
    this.service.playersForm.setValue(null)
  }

  filterPlayers(){
    const filterValue = this.playerInput.nativeElement.value.toLowerCase()
    if(filterValue.length > 3)
    this.playersFiltered = this.players.filter(m => m.name.toLowerCase().includes(filterValue))
  }
}